import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ScatteredSection } from './components/ScatteredSection';
import { SystemSection } from './components/SystemSection';
import { Modules } from './components/Modules';
import { LookInside } from './components/LookInside';
import { Bonuses } from './components/Bonuses';
import { NotEbook } from './components/NotEbook';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
const PIXEL_ID = '1005118822521193';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    const pixelWindow = window as PixelWindow;
    try {
      if (!pixelWindow.fbq) {
        const fbq = ((...args: unknown[]) => {
          if (fbq.callMethod) {
            fbq.callMethod(...args);
          } else {
            fbq.queue?.push(args);
          }
        }) as PixelFunction;
        pixelWindow.fbq = fbq;
        if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript?.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          document.head.appendChild(script);
        }
      }
      pixelWindow.fbq?.('init', PIXEL_ID);
      pixelWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="86w5ms80s80u">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="86cld4uwd7jn" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-carbon" data-id="element-2" data-mp="3bkgs07dqsbe7">
        {showPurchasePopup && <PurchasePopup data-id="element-3" data-mp="3qd0sf09ic4ry" />}
        <main data-id="element-4" data-mp="3lkr2hk8e74po">
          <Hero data-id="element-5" data-mp="3lk7kk3iqsgbn" />
          <PainSection data-id="element-6" data-mp="3ljpiurdb99wc" />
          <ScatteredSection data-id="element-7" data-mp="3lieeoqfye04p" />
          <SystemSection data-id="element-8" data-mp="2xun1zlqi3l2w" />
          <Modules data-id="element-9" data-mp="2xtv609szrlc3" />
          <LookInside data-id="element-10" data-mp="2xtbyln0ywfcb" />
          <Bonuses data-id="element-11" data-mp="2xssf41vo5iw6" />
          <NotEbook data-id="element-12" data-mp="2svtr812lm86f" />
          <Offer data-id="element-13" data-mp="2swll97gjrxul" />
          <Guarantee data-id="element-14" data-mp="2sv0orcaoa4u3" />
          <Testimonials data-id="element-15" data-mp="2svjyi5q65mx1" />
          <FAQ data-id="element-16" data-mp="18driltpr7bcr" />
          <FinalCTA data-id="element-17" data-mp="18d9e69sxtqtr" />
        </main>
        <Footer data-id="element-18" data-mp="18czpcpjmpppn" />
      </div>
    </>;
}